// src/tasks/lib/tasks-switch.ts
// Task management R1 ships dark behind the per-browser switch `?x=tasks` (encounter-flags.ts), the repo's pattern for a
// new surface before the demo. OFF: no rail entry, and the /tasks route says the page is off without calling the store.
import { isEncounterFlagOn } from '@/shared/lib/encounter-flags';
import { isAlliedHealth, isDoctor, isNurse, ORG_ADMIN_ROLE } from '@/auth/roles';
import type { UserData } from '@/auth/types';

export const isTasksOn = (): boolean => isEncounterFlagOn('tasks');

/** Who may raise a task from the Tasks page: physician, nurse, administrator (the app's role helpers). The server checks Task_Write. */
export function mayCreateTask(u: Pick<UserData, 'role' | 'tenantRoleId' | 'isOnboarded'> | null | undefined): boolean {
  if (!u) return false;
  if (isDoctor(u) && !isAlliedHealth(u)) return true;
  if (isNurse(u)) return true;
  return String(u.role ?? '') === ORG_ADMIN_ROLE;
}
